<div class="document-category d-flex flex-column">
    <div class="card item-card">
        <div class="card-body d-flex flex-column">
            <div class="mb-3">
                <span>{{'common.uploadDocuments' | translate}}</span>
                <span class="px-2">
                    {{'common.or' | translate }}
                </span>
                <button type="button" class="btn primary-btn image-capture-btn" (click)="openImageCaptureModal()">
                    <i class="app-icon icon icon-image-take icon-xl me-2"></i>
                    <span>{{ 'common.scan' | translate }}</span>
                </button>
            </div>
            <div class="upload-component d-flex flex-column">
                <div class="import-file-container mb-5">
                    <input
                        type="file"
                        class="input-file cursor-pointer"
                        [accept]="acceptExtensions"
                        (change)="uploadFileInStoreHandler($event)"/>
                    <div class="import-file-label d-flex flex-column align-items-center gap-2">
                        <div class="upload-icon-box d-flex align-items-center justify-content-center">
                            <i class="app-icon icon icon-upload icon-lg"></i>
                        </div>
                        <div class="upload-info text-center">
                            <div class="upload-hint mb-1" [innerHTML]="'common.uploadPresentationDocument' | translate">
                            </div>
                            <div class="upload-note">
                                {{ 'PDF '+ ('common.or' | translate) +' WORD' }}
                            </div>
                      </div>
                    </div>
                </div>

                <ng-container *ngFor="let doc of toUploadDocuments; let isLast = last, let index=index">
                    <div class="document-item d-flex flex-column flex-md-row align-items-md-center gap-3">
                        <div class="document-name d-flex align-items-center gap-3">
                            <i class="app-icon icon icon-file icon-xxxl2"></i>
                            <span HJSuppress class="fw-bold">{{doc.documentName}}</span>
                        </div>
                        <div class="d-flex gap-3 justify-content-between flex-grow-1">
                            <div class="flex-grow-1">
                                <div class="upload-label fw-semibold">{{'common.uploaded' | translate}}</div>
                                <div HJSuppress class="fw-bold">{{doc.documentDate | localizedDate}}</div>
                            </div>
                            <button class="btn delete-btn custom-delete-btn" (click)="removeFileHandler(index)">
                                <i class="app-icon icon icon-delete icon-xl"></i>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>

            <button
                type="button"
                class="btn primary-btn align-self-center"
                [ngClass]="{'mt-5' : toUploadDocuments.length > 0}"
                [disabled]="!(toUploadDocuments.length > 0)"
                (click)="uploadFileToRequestHandler()"
            >
                {{ 'common.send' | translate }}
            </button>
        </div>
    </div>

    <ng-container *ngIf="documents && documents.length > 0">
        <div class="card item-card user-documents-box" *ngIf="(documents | filterArray: filterUserRecordsCallback)?.length > 0">
            <div class="card-body">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
                    <h3 class="fw-bold flex-grow-1">
                        {{'requests.details.category.userDocuments' | translate}}
                    </h3>
                    <button class="btn gap-2 m-outline-btn align-self-end" 
                        (click)="downloadAllDocumentsHandler(isAdmin ? 
                            DOCUMENT_CATEGORY_SECTION.LEASING_PARTNER :
                            DOCUMENT_CATEGORY_SECTION.USER)">
                        <i class="app-icon icon icon-download icon-xl"></i>
                        <span>{{'requests.details.category.downloadAll' | translate}}</span>
                    </button>
                </div>
                <ng-container *ngFor="let doc of documents | filterArray: filterUserRecordsCallback; let isLast = last">
                    <div class="document-item d-flex flex-column flex-md-row align-items-md-center gap-3">
                        <div class="document-name d-flex align-items-center gap-3">
                            <i class="app-icon icon icon-file icon-xxxl2"></i>
                            <span HJSuppress class="fw-bold">{{doc.documentName}}</span>
                        </div>
                        <div class="d-flex gap-3 justify-content-between flex-grow-1">
                            <div class="flex-grow-1">
                                <div class="upload-label fw-semibold">{{'common.uploaded' | translate}}</div>
                                <div HJSuppress class="fw-bold">{{doc.documentDate | localizedDate}}</div>
                            </div>
                            <div *ngIf="isAdmin" class="flex-grow-1">
                                <span class="d-flex flex-column">
                                    <span class="upload-label">{{'common.downloadedAt' | translate}}</span>
                                    <span HJSuppress class="fw-bold">{{doc.userFirstDownloadDate | date:'short'}}</span>
                                </span>
                            </div>
                            <button class="btn m-outline-btn" (click)="downloadDocument(doc)">
                                <i class="app-icon icon icon-download icon-xl"></i>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="card item-card leasing-partner-documents-box" *ngIf="(documents | filterArray: filterPartnerRecordsCallback)?.length > 0">
            <div class="card-body">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
                    <h3 class="fw-bold flex-grow-1">
                        {{ (isAdmin ? 'requests.details.category.clientDocuments' :'requests.details.category.partnerDocuments') | translate }}
                    </h3>
                    <button class="btn gap-2 m-outline-btn align-self-end" 
                        (click)="downloadAllDocumentsHandler(isAdmin ? 
                            DOCUMENT_CATEGORY_SECTION.USER :
                            DOCUMENT_CATEGORY_SECTION.LEASING_PARTNER)">
                        <i class="app-icon icon icon-download icon-xl"></i>
                        <span>
                            {{ (isAdmin ? 'requests.details.category.clientDocuments' :'requests.details.category.partnerDocuments') | translate }}
                        </span>
                    </button>
                </div>
                <ng-container *ngFor="let doc of documents | filterArray: filterPartnerRecordsCallback; let isLast = last">
                    <div class="document-item d-flex flex-column flex-md-row align-items-md-center gap-3">
                        <div class="document-name d-flex align-items-center gap-3">
                            <i class="app-icon icon icon-file icon-xxxl2"></i>
                            <span HJSuppress class="fw-bold">{{doc.documentName}}</span>
                        </div>
                        <div class="d-flex gap-3 justify-content-between flex-grow-1">
                            <div class="flex-grow-1">
                                <div class="upload-label fw-semibold">{{'common.uploaded' | translate}}</div>
                                <div HJSuppress class="fw-bold">{{doc.documentDate | localizedDate}}</div>
                            </div>
                            
                            <button class="btn m-outline-btn" (click)="downloadDocument(doc)">
                                <i class="app-icon icon icon-download icon-xl"></i>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>